import React, { useEffect, useState } from "react";
import {
  Dropdown,
  Input,
  RadioGroup,
  Radio,
  Option,
  Combobox,
} from "@fluentui/react-components";
import SearchResourceInGraph from "./SearchResourceInGraph";
import { useTranslation } from "react-i18next";
import { transferTargetTypeFor } from "../../Services/resourceAccount";
export default function Fallback(props) {
  const { t } = useTranslation();
  const inputItems = ["phone", "user", "voicemail"];

  /**
   * « app » n'est PAS proposé dans la liste, et c'est délibéré.
   *
   * Le type d'une cible Teams n'est pas un choix : c'est un fait, que Graph nous apprend. Laisser
   * l'administrateur trancher entre « user » et « app » n'ajouterait qu'une occasion de se
   * tromper — et une erreur ici ne se voit pas : un compte ressource enregistré comme « user »
   * produit un identifiant valide désignant un utilisateur inexistant, donc un transfert qui ne
   * sonne jamais, sans message.
   *
   * L'administrateur choisit donc « user » — au sens « une cible Teams » — et on affine à
   * l'enregistrement selon ce que le compte EST. La console agent procède de même.
   *
   * La valeur « app » reste affichable : un flux déjà configuré doit se rouvrir sans que le
   * sélecteur paraisse vide ni que le champ de recherche disparaisse.
   */
  const targetTypeLabel = (item) =>
    item === "app" ? t("RESOURCE_ACCOUNT", { defaultValue: "resource account" }) : item;
  const shownItems = props.valueTargetType === "app" ? [...inputItems, "app"] : inputItems;
  const isGraphTarget =
    props.valueTargetType === "user" ||
    props.valueTargetType === "voicemail" ||
    props.valueTargetType === "app";

  const [queues, setQueues] = useState([]);
  const [query, setQuery] = useState(props.valueName);

  // Mettre à jour query quand valueName change (ex: après refresh)
  useEffect(() => {
    if (props.valueName) {
      setQuery(props.valueName);
    }
  }, [props.valueName]);

  // Préparation des queues (formatage nom + id)
  useEffect(() => {
    if (props.QUEUES) {
      // Convert object to array of its values
      const extractedQueues = Array.isArray(props.QUEUES)
        ? props.QUEUES.flatMap((obj) => Object.values(obj || {}))
        : Object.values(props.QUEUES); // ✅ handle object form
  
      // Map to uniform structure
      const formatted = extractedQueues.map((q) => ({
        key: q.id,
        value: q.id,
        queueName: q.queueName,
      }));
  
      setQueues(formatted);
    }
  }, [props.QUEUES]);
  
  const filteredOptions = queues
    .filter((q) => q.queueName?.toLowerCase().includes(query.toLowerCase()))
    .map((q) => (
      <Option key={q.key} value={q.value}>
        {q.queueName}
      </Option>
    ));
  return (
    <div>
      <RadioGroup
        className="radio-group-style "
        layout="horizontal"
        value={props.typeValue}
        disabled={props.disabled}
        onChange={(_, data) => {
          props.setFallBackType(data.value);
        }}
      >
        <Radio value="disconnect" label={t("DISCONNECT")} />
        <Radio value="transfer" label={t("TRANSFER_TO")} />
        <Radio value="queue" label={t("QUEUE")} />
      </RadioGroup>
      {props.typeValue === "transfer" && (
        <>
          <Dropdown
            clearable
            className="dropdown-inline"
            placeholder={t("SELECT_SCOPE")}
            value={props.valueTargetType}
            disabled={props.disabled}
            onOptionSelect={(_, data) => {
              props.updateTargetType(_,data);
            }}
          >
            {shownItems.map((item, index) => (
              <Option key={index} value={item}>
                {targetTypeLabel(item)}
              </Option>
            ))}
          </Dropdown>
          {props.valueTargetType === "phone" && (
            <div >
              <Input
                clearable
                className="dropdown-inline phone-number-input"
                value={props.targetId}
                disabled={props.disabled}
                onChange={(event, data) => {
                  props.updateTargetId(event, data);
                }}
              />
            </div>
          )}
          {isGraphTarget && (
            <div className="search-user-queue-style">
              <SearchResourceInGraph
                displayName={props.displayName}
                onSelectUser={(user) => {
                  // Le type est déduit ICI et transmis en 2e argument, plutôt que posé par un
                  // appel séparé à updateTargetType : les deux écritures partiraient dans le même
                  // tick sur un état construit par étalement, et la seconde écraserait la
                  // première. Un seul appel, un seul état.
                  //
                  // « voicemail » n'est pas concerné : c'est une messagerie d'utilisateur, elle
                  // ne peut pas désigner un compte ressource.
                  const targetType =
                    props.valueTargetType === "voicemail"
                      ? "voicemail"
                      : transferTargetTypeFor(user);
                  props.searchUser(user, targetType);
                }}
                isUpdate={props.isUpdate}
                disabled={props.disabled}
              />
            </div>
          )}
        </>
      )}
      {props.typeValue === "queue" && (
        <Combobox
          className="dropdown-inline"
          placeholder={t("SEARCH_QUEUE")}
          value={query}
          disabled={props.disabled}
          onChange={(e) => setQuery(e.target.value)}
          onOptionSelect={(_, data) => {
            const selectedQueue = queues.find(
              (q) => q.value === data.optionValue
            );
            if (selectedQueue) {
              props.onQueueSelect(selectedQueue);
              setQuery(selectedQueue.queueName);
            }
          }}
        >
          {filteredOptions}
        </Combobox>
      )}
    </div>
  );
}
